var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.96967 18.0307C2.26256 18.3236 2.73744 18.3236 3.03033 18.0307L8.13117 12.9299L11.2968 16.0955C11.4374 16.2361 11.6282 16.3151 11.8271 16.3151C12.026 16.3151 12.2168 16.2361 12.3574 16.0955L13.7716 14.6812C13.9313 14.5215 14.0105 14.2983 13.9873 14.0736L13.7012 11.3118L17.9906 7.67324C18.1504 7.53767 18.2462 7.34141 18.2548 7.13201C18.2634 6.92261 18.1839 6.71917 18.0357 6.57097L13.161 1.69623C13.0128 1.54804 12.8094 1.46861 12.6 1.47719C12.3906 1.48577 12.1943 1.58157 12.0587 1.74138L8.42007 6.03059L5.6582 5.74457C5.43353 5.7213 5.21033 5.80053 5.05061 5.96025L3.6364 7.37446C3.49574 7.51511 3.41673 7.70587 3.41673 7.90479C3.41672 8.1037 3.49574 8.29447 3.6364 8.43512L7.0705 11.8692L1.96967 16.9701C1.67678 17.263 1.67678 17.7378 1.96967 18.0307Z",
    fill: "#06070D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.7fe00ded54144f2d3e66a9bc8cda8eb4.svg";
export { ForwardRef as ReactComponent };